/** Russian strings for `uz-w2-bookings.ts`. Spread into `ru`; a missing key falls back to Uzbek. */
import type { TranslationKey } from "./uz";

export const ruBookingsW2: Partial<Record<TranslationKey, string>> = {
  "bookingW2.actions": "Действия",
  "bookingW2.documents": "Документы",
  "bookingW2.documents.title": "Документы брони",
  "bookingW2.documents.empty": "Документов нет",
  "bookingW2.documents.kind": "Тип документа",
  "bookingW2.documents.kind.voucher": "Ваучер",
  "bookingW2.documents.kind.ticket": "Билет",
  "bookingW2.documents.kind.insurance": "Страховка",
  "bookingW2.documents.file": "Файл (JPG, PNG, WEBP или PDF, до 10 МБ)",
  "bookingW2.documents.upload": "Загрузить",
  "bookingW2.documents.open": "Открыть",
  "bookingW2.documents.uploaded": "Документ загружен",
  "bookingW2.documents.failed": "Не удалось загрузить",
  "bookingW2.documents.openFailed": "Не удалось открыть документ.",
  "bookingW2.check": "Проверить статус",
  "bookingW2.check.moved": "Статус брони обновлён: {status}.",
  "bookingW2.check.same": "В кабинете: {status}. Статус брони не изменился.",
  "bookingW2.check.notFound": "Этот номер не найден в кабинете туроператора.",
  "bookingW2.check.failed": "Не удалось проверить.",
  "bookingW2.fromVariant": "Заполнить из варианта, выбранного клиентом",
  "bookingW2.fromVariant.done": "Заполнено по варианту «{hotel}».",

  "paymentW2.receipt": "Чек (изображение или PDF)",
  "paymentW2.receipt.open": "Чек",
  "paymentW2.receipt.failed": "Не удалось открыть чек.",

  "dealsW2.export": "Экспорт",
  "dealsW2.export.failed": "Не удалось выполнить экспорт.",

  "pricingW2.open": "Наценка и скидка",
  "pricingW2.title": "{name}: наценка и скидка",
  "pricingW2.hint": "Правило применяется к следующим ценам поиска этого туроператора. Клиент видит только цену продажи.",
  "pricingW2.empty": "Правил нет. Применяется общая наценка агентства.",
  "pricingW2.scope": "Направление",
  "pricingW2.scope.all": "Все направления",
  "pricingW2.method": "Тип наценки",
  "pricingW2.method.percent": "Процент",
  "pricingW2.method.fixed_per_pax": "Сумма на человека",
  "pricingW2.value": "Наценка",
  "pricingW2.currency": "Валюта",
  "pricingW2.discount": "Скидка, %",
  "pricingW2.active": "Включено",
  "pricingW2.off": "Отключено",
  "pricingW2.turnOff": "Отключить",
  "pricingW2.turnOn": "Включить",
  "pricingW2.saved": "Правило сохранено",
  "pricingW2.failed": "Не удалось сохранить правило.",
};
